import type { DiffRowStatus, DiffSectionKind } from './types';
import type { TextLineType } from './computeTextDiff';

export const DIFF_BG: Record<DiffRowStatus, string> = {
  added: 'bg-emerald-50/70',
  removed: 'bg-red-50/70',
  changed: 'bg-amber-50/60',
  unchanged: '',
};

export const DIFF_SIGN: Record<DiffRowStatus, string> = {
  added: '+',
  removed: '−',
  changed: '~',
  unchanged: '',
};

export const DIFF_SIGN_COLOR: Record<DiffRowStatus, string> = {
  added: 'text-emerald-600',
  removed: 'text-red-600',
  changed: 'text-amber-600',
  unchanged: 'text-neutral-300',
};

export const KIND_LABELS: Record<DiffSectionKind, string> = {
  items: 'položky',
  fields: 'parametry',
  text: 'text',
  files: 'soubory',
};

export const TEXT_BG: Record<TextLineType, string> = {
  ctx: '',
  add: 'bg-emerald-50/70',
  del: 'bg-red-50/70',
};

export const TEXT_SIGN: Record<TextLineType, string> = {
  ctx: '',
  add: '+',
  del: '−',
};

export const TEXT_SIGN_COLOR: Record<TextLineType, string> = {
  ctx: 'text-neutral-300',
  add: 'text-emerald-600',
  del: 'text-red-600',
};
